export default __webpack_public_path__ + "static/media/21_gallery.cd9cc26d.jpg";